/**
 * useFirstVisit — true so na primeira render por rota durante a sessao.
 *
 * Evita motion fatigue: animacoes de mount rodam apenas uma vez por sessao
 * em cada rota. Subsequent re-mounts (navegacao back/forward) caem pra
 * estado final imediato (sem animar).
 *
 * Storage: sessionStorage (resetado ao fechar aba).
 */

import { useRef } from 'react';

const STORAGE_KEY = 'aura.firstVisit.v1';

function readVisited(): Set<string> {
  if (typeof window === 'undefined') return new Set();
  try {
    const raw = window.sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return new Set();
    const parsed: unknown = JSON.parse(raw);
    return new Set(Array.isArray(parsed) ? parsed.filter((x): x is string => typeof x === 'string') : []);
  } catch {
    return new Set();
  }
}

function markVisited(key: string) {
  if (typeof window === 'undefined') return;
  try {
    const set = readVisited();
    set.add(key);
    window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify([...set]));
  } catch {
    // silent
  }
}

export function useFirstVisit(routeKey: string): boolean {
  // Resolve uma unica vez por render lifecycle (ref evita re-trigger em re-render).
  const decided = useRef<boolean | null>(null);
  if (decided.current === null) {
    const visited = readVisited();
    decided.current = !visited.has(routeKey);
    if (decided.current) markVisited(routeKey);
  }
  return decided.current;
}
